import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1502edbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-primary" }, "Tere tulemast Kriminaalhooldusportaali!", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Kriminaalhooldusportaali eesmärgiks on toetada Teie kriminaalhoolduse läbimist. Kriminaalhooldusega seotud informatsioon on koondunud siia ning täieneb pidevalt. Saate iseseivalt, endale sobival ajal tutvuda dokumentidega ja kõige muuga, mis kriminaalhooldust puudutab. Tegemist on Teie isikliku virtuaalse toimikuga. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-textDark ma-2 pa-2" }, "Nõusolek", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-textDark mb-4" }, "Tingimused, millega hooldusalune nõustub Kriminaalhooldusportaali kasutades.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, " Dokumendi kättetoimetamine on üks dokumendi teatavaks tegemise viis ning tähendab dokumendi originaali või ametlikult kinnitatud koopia edastamist adressaadile. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, " Elektrooniliselt kättesaadavaks tehtud või edastatud dokument loetakse kättetoimetatuks, kui olete dokumendi avanud või vastu võtnud ja/või kinnitanud edastatud dokumendi kättesaamise. ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, " Elektrooniline kättetoimetamine eeldab, et olete haldusorganile oma võimalustest ning soovist võtta vastu elektrooniliselt edastatud dokument eelnevalt teada andnud – selleks piisab ühekordsest tahteavaldusest. ", -1))
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, " Juhul kui Te ei kinnita ülevaltoodud tingimusi, siis puudub võimalus Kriminaalhooldusportaali kasutada. ", -1))
const _hoisted_10 = { class: "text-right" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Teie nõusolek on kinnitatud!", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Dokumendi/dokumentide kättetoimetamine toimub Teie nõusolekul edaspidi elektrooniliselt. Dokumendid tehakse kättesaadavaks käesolevas portaalis.", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Teie mittenõustumine on kinnitatud!", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Teil puudub võimalus Kriminaalhooldusportaali kasutada.", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, "Juhul kui te ei ole tingimustega nõus, siis edaspidi puudub võimalus Kriminaalhooldusportaali kasutada!", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Kas endiselt soovite mittenõustuda?", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_VoDialoog = _resolveComponent("VoDialoog")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_KRHPTyhiPaigutus = _resolveComponent("KRHPTyhiPaigutus")!

  return (_openBlock(), _createBlock(_component_KRHPTyhiPaigutus, { portaaliPealkiri: "Tere tulemast Kriminaalhooldusportaali!" }, {
    title: _withCtx(() => [
      _createVNode(_component_v_card, { class: "ma-2 pa-2" }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    body: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_component_v_card, { class: "ma-2 pa-2" }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _hoisted_5,
                  _hoisted_6,
                  _hoisted_7,
                  _createElementVNode("p", _hoisted_8, [
                    _createTextVNode(" Tuginedes eeltoodule: "),
                    _createVNode(_component_v_list, {
                      lines: "one",
                      class: "pl-5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item, { title: "Kinnitan, et mul on võimalus elektrooniliselt edastatud dokumente avada või vastu võtta ning\n                                vajadusel kinnitada." }),
                        _createVNode(_component_v_list_item, { title: "Kinnitan, et soovin võtta vastu elektrooniliselt edastatud dokumente ning olen teadlik, et\n                                dokument/dokumendid tehakse kättesaadavaks antud infosüsteemis." }),
                        _createVNode(_component_v_list_item, { title: "Olen teadlik, et mul on õigus antud tahteavaldusest loobuda, selleks pean tegema\n                                vastavasisulise tahteavalduse ametnikule." }),
                        _createVNode(_component_v_list_item, { title: "Olen teadlik, et kui soovin dokumenti paberkandjal või e-posti aadressile, siis teavitan\n                                eraldi sellest ametnikku." })
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_9,
                  _createElementVNode("p", _hoisted_10, [
                    _createVNode(_component_v_btn, {
                      class: "mr-2 font-weight-bold",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mittenoustumineDialoog.lylitaDialoog())),
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Ei kinnita")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      class: "font-weight-bold",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.kinnita())),
                      size: "large",
                      color: "light-blue-darken-3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Kinnitan")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_VoDialoog, {
                    ref: "noustumineDialoog",
                    stiil: 1,
                    "onUpdate:nahtav": _cache[2] || (_cache[2] = ($event: any) => (_ctx.kasutajaSuunamine($event)))
                  }, {
                    pealkiri: _withCtx(() => [
                      _createTextVNode("Tingimustega nõustumine")
                    ]),
                    default: _withCtx(() => [
                      _hoisted_11,
                      _hoisted_12
                    ]),
                    _: 1
                  }, 512),
                  _createVNode(_component_VoDialoog, {
                    ref: "mittenoustumineKinnitatudDialoog",
                    stiil: 1
                  }, {
                    pealkiri: _withCtx(() => [
                      _createTextVNode("Tingimustega mittenõustumine kinnitatud")
                    ]),
                    nupud: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        size: "large",
                        variant: "elevated",
                        class: "font-weight-bold",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.logiValja())),
                        color: "light-blue-darken-3"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Logi välja")
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_13,
                      _hoisted_14
                    ]),
                    _: 1
                  }, 512),
                  _createVNode(_component_VoDialoog, {
                    ref: "mittenoustumineDialoog",
                    stiil: 2
                  }, {
                    pealkiri: _withCtx(() => [
                      _createTextVNode(" Tingimustega mittenõustumine")
                    ]),
                    nupud: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        class: "font-weight-bold",
                        variant: "elevated",
                        size: "large",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.eiKinnita()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Jah")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        class: "font-weight-bold",
                        variant: "elevated",
                        size: "large",
                        color: "light-blue-darken-3",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.mittenoustumineDialoog.lylitaDialoog()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Ei")
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_15,
                      _hoisted_16
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}